import beFeed from 'actions/activity/beFeed.action';
import {
  aTypeGetClientActivityFeed,
  aTypeMarkActivityFeedItemAsNotSeen,
  aTypeMarkActivityFeedItemAsNotUseful,
  aTypeMarkActivityFeedItemAsSeen,
  aTypeMarkActivityFeedItemAsSeenAtMutu,
  aTypeMarkActivityFeedItemAsUseful,
  aTypeMutuCallNumber,
} from 'actions/shared.types';
import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import fromActionTypeToArray from 'utils/converters/mw/fromActionTypeToArray.util';

// TODO: seems unused, check and if so, remove it
export const getClientActivityFeed = (salonId, clientId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/v2/${salonId}/client/${clientId}/activity/`,
    authenticated: true,
    types: fromActionTypeToArray(aTypeGetClientActivityFeed),
  },
});

export const markActivityFeedItemAsUseful = (itemId) => ({
  [AUTH_API]: {
    api_root: CONF.activityApiRoot,
    endpoint: `feed/useful/${itemId}/`,
    authenticated: true,
    types: ['', aTypeMarkActivityFeedItemAsUseful.name, beFeed.AT.fail],
    config: { method: 'POST', headers: { 'Content-Type': 'application/json' } },
  },
});

export const markActivityFeedItemAsNotUseful = (itemId) => ({
  [AUTH_API]: {
    api_root: CONF.activityApiRoot,
    endpoint: `feed/useful/${itemId}/`,
    authenticated: true,
    types: ['', aTypeMarkActivityFeedItemAsNotUseful.name, beFeed.AT.fail],
    config: { method: 'DELETE', headers: { 'Content-Type': 'application/json' } },
    params: { id: itemId },
  },
});

export const markActivityFeedItemAsSeen = (itemId) => ({
  [AUTH_API]: {
    api_root: CONF.activityApiRoot,
    endpoint: `feed/seen/${itemId}/`,
    authenticated: true,
    types: ['', aTypeMarkActivityFeedItemAsSeen.name, beFeed.AT.fail],
    config: { method: 'POST', headers: { 'Content-Type': 'application/json' } },
    params: { id: itemId },
  },
});

export const markActivityFeedItemAsSeenAtMutu = (callId, salonId) => ({
  [AUTH_API]: {
    api_root: CONF.phoneApiRoot,
    endpoint: `mutu/actioncall/${salonId}/`,
    authenticated: true,
    types: ['', aTypeMarkActivityFeedItemAsSeenAtMutu.name, beFeed.AT.fail],
    config: { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ callId }) },
  },
});

export const mutuCallNumber = (salonId, phone) => ({
  [AUTH_API]: {
    api_root: CONF.phoneApiRoot,
    endpoint: `mutu/clicktocall/${salonId}/`,
    authenticated: true,
    types: fromActionTypeToArray(aTypeMutuCallNumber),
    params: { phone },
    config: { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ phone }) },
  },
});

export const markAsSeen = (itemId, callId, salonId) => async (dispatch) => {
  const feedResult = await dispatch(markActivityFeedItemAsSeen(itemId));

  if (feedResult.type !== aTypeMarkActivityFeedItemAsSeen.name || !callId) return { feedResult };

  const mutuResult = dispatch(markActivityFeedItemAsSeenAtMutu(callId, salonId));
  return { feedResult, mutuResult };
};

export const markActivityFeedItemAsNotSeen = (itemId) => ({
  [AUTH_API]: {
    api_root: CONF.activityApiRoot,
    endpoint: `feed/seen/${itemId}/`,
    authenticated: true,
    types: ['', aTypeMarkActivityFeedItemAsNotSeen.name, beFeed.AT.fail],
    config: { method: 'DELETE', headers: { 'Content-Type': 'application/json' } },
    params: { id: itemId },
  },
});
